import axios from "axios";
import router from "../router/index.js";

const goUrl = url => {
  router.replace({
    path: url
  });
};

// 配置请求信息
const API = axios.create({
  baseURL: "",
  timeout: "30000", //请求超时时间
  headers: {
    //"X-Requested-With": "XMLHttpRequest",
    // "Content-Type": "multipart/form-XMLHttpRequest"
    //"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    "Content-Type": "application/json; charset=UTF-8"
    // 'Content-Type': 'application/x-www-form-urlencoded'
    //   'X-Requested-With': 'XMLHttpRequest',
    // 'Access-Control-Allow-Origin': 'http://192.168.10.90:8009'
  } //header传值，例如：Authorization
});

// 允许跨越携带cookie信息
API.defaults.withCredentials = true;

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      //console.log("未登录状态");
      break;
      // 403 token过期
      // 清除token并跳转登录页
    case 403:
      //console.log("登录过期，请重新登录");
      break;
      // 404请求不存在
    case 404:
      // goUrl('/404')
      break;
    case 500:
      // alert("服务器出现错误");
      break;
    default:
      //console.log("其他");
  }
};

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
API.interceptors.request.use(
  res => Promise.resolve(res),

  error => Promise.error(error)
);

// 响应拦截器
API.interceptors.response.use(
  // 请求成功
  //res => (res.status === 200 ? Promise.resolve(res) : Promise.reject(res)),
  res => {
    if (res.status === 200) {
      //debugger

      if (res.data && res.data.msg && !res.data.isSuccess && res.data.msg.indexOf("未登录") >= 0) {

        goUrl("/login/index?backurl=" + location.href);

      } else return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  },
  // 请求失败
  error => {
    const {
      response
    } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明

        // 当用户网络环境差时，注册请求超时会跳转到首页导致用户没有入口再去注册
      // goUrl("/timeOut");

    }
  }
);

//axios跨域请求
API.jsonp = url => {
  if (!url) {
    console.error("Axios.JSONP 至少需要一个url参数!");
    return;
  }
  return new Promise((resolve, reject) => {
    window.jsonCallBack = result => {
      resolve(result);
    };
    var JSONP = document.createElement("script");
    JSONP.type = "text/javascript";
    JSONP.src = `${url}&callback=jsonCallBack`;
    document.getElementsByTagName("head")[0].appendChild(JSONP);
    setTimeout(() => {
      document.getElementsByTagName("head")[0].removeChild(JSONP);
    }, 500);
  });
};

export default API;



// WEBPACK FOOTER //
// ./src/api/http.js